export * from './lib/portal-shared-icon.module';
